import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import queryString from 'query-string';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import API from '../../api';
import { ModalCreditAction, PageHeader } from '../../components';
import { SnackbarContext, UserContext } from '../../contexts';
import { modalStyle } from '../../styles/style';
import { CreditForm } from './form/CreditForm';
import { useCredit } from './hooks';

const renderBreadcrumbsTitle = (type) => {
  if (type === 'issue') return 'APPLY_VRC_ISSUE';
  if (type === 'move') return 'TRANSFER_VRC';
  if (type === 'offset') return 'REQ_WITHDRAWAL';
  if (type === 'retire') return 'REQ_DISPOSAL';
  return '';
};

export const CreditWritingPage = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const searchObject = queryString.parse(history.location.search);
  const slug = searchObject.seq ? Number(searchObject.seq) : null;
  const {
    postIssue,
    postMove,
    postOffset,
    postRetire,
    putIssue,
    putMove,
    putOffset,
    putRetire,
    credit,
    getIssue,
    getMove,
    getOffset,
    getRetire,
  } = useCredit();
  const mode = location.pathname.split('/')[location.pathname.split('/').length - 1];
  const { userInfo } = useContext(UserContext);
  const { updateSnackbar } = useContext(SnackbarContext);
  const [actionOpen, setActionOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedNextAction, setSelectedNextAction] = useState(null);

  const closeActionModal = () => {
    setActionOpen(false);
    setSelectedAction(null);
    setSelectedNextAction(null);
  };

  const handleModalRequest = async (body) => {
    try {
      await API.Credit.PostNextAction(slug, body);
      closeActionModal();
      history.push('/credit/list');
    } catch (err) {
      updateSnackbar({
        type: 'error',
        open: true,
        message: err.data.message,
      });
    }
  };

  const handlePost = async (data) => {
    if (mode === 'issue') {
      await postIssue(data);
    } else if (mode === 'move') {
      await postMove(data);
    } else if (mode === 'offset') {
      await postOffset(data);
    } else if (mode === 'retire') {
      await postRetire(data);
    }
  };

  const handlePut = async (data) => {
    let res = null;
    if (mode === 'issue') {
      res = await putIssue(slug, data);
    } else if (mode === 'move') {
      res = await putMove(slug, data);
    } else if (mode === 'offset') {
      res = await putOffset(slug, data);
    } else if (mode === 'retire') {
      res = await putRetire(slug, data);
    }

    if (res !== true) {
      return;
    }
    /* 보완 PUT API 요청 후 Action 처리 */
    if (credit.actionSeq.status === 'WritingZCCreditForImprove') {
      setSelectedNextAction('ImproveZCCreditComplete');
    } else if (credit.actionSeq.status === 'WritingCommitteeForImprove') {
      setSelectedNextAction('ImproveCommitteeComplete');
    } else {
      return;
    }

    setSelectedAction({
      seq: slug,
    });
    setActionOpen(true);
  };

  const onSubmit = (data) => {
    if (slug) {
      handlePut(data);
    } else {
      handlePost(data);
    }
  };

  useEffect(() => {
    if (slug) {
      if (mode === 'issue') {
        getIssue(slug);
      } else if (mode === 'move') {
        getMove(slug);
      } else if (mode === 'offset') {
        getOffset(slug);
      } else if (mode === 'retire') {
        getRetire(slug);
      }
    }
  }, [slug, mode]);

  if (!userInfo) {
    return null;
  }

  return (
    <article className='basic-page'>
      <PageHeader type='credit' title={t(renderBreadcrumbsTitle(mode))}></PageHeader>
      <article className='container max-w-screen-lg mx-auto pt-10'>
        <div className='grid grid-cols-2 gap-4'>
          <div>
            <span className='text-sm text-gray-600'>{t('COMPANY_NAME')}: </span>
            <span className='text-sm font-medium'>{userInfo?.companyName}</span>
          </div>
          <div>
            <span className='text-sm text-gray-600'>{t('CEO_NAME')}: </span>
            <span className='text-sm font-medium'>{userInfo?.ceoName}</span>
          </div>
          <div>
            <span className='text-sm text-gray-600'>{t('BIZ_NUMBER')}: </span>
            <span className='text-sm font-medium'>{userInfo?.businessNumber}</span>
          </div>
          <div>
            <span className='text-sm text-gray-600'>{t('MOBILE')}: </span>
            <span className='text-sm font-medium'>{userInfo?.phone}</span>
          </div>
        </div>
        <div className='pt-10 mt-10 border-t border-solid border-gray-200'>
          <CreditForm type={mode} credit={credit} onSubmit={onSubmit} />
        </div>
      </article>
      <Modal open={actionOpen} onClose={closeActionModal}>
        <Box sx={modalStyle}>
          <ModalCreditAction
            action={selectedAction}
            nextAction={selectedNextAction}
            requestAction={handleModalRequest}
            onClose={closeActionModal}
          ></ModalCreditAction>
        </Box>
      </Modal>
    </article>
  );
};
